import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { SafeUrl, SafeHtml } from '@angular/platform-browser';


@Injectable({
  providedIn: 'root'
})
export class SharedMenuService {

  // Observable  sources
  private companyListSource = new Subject<companyDetails[]>();
  private loginStateSource = new Subject<boolean>();
  private menuItemsSource = new Subject<menuAppItems[]>()
  private currentUserSource = new Subject<currentUser>()
  private notificationListSource = new Subject<notification[]>();
  private companyIndiceSource = new Subject<string>();
  private appTitleSource = new Subject<string>();
  private appSubTitleSource = new Subject<string>();
  private menuIconSource = new Subject<string>();
  private loadingStateSource = new Subject<boolean>();
  private snackBarIsCloseSource = new Subject<boolean>();
  private snackBarCloseSource = new Subject<null>();
  private poolDragAndDropSource = new Subject<any>();
  private dragAndDropMvtSource = new Subject<boolean>();
  private HelpButtonSource = new Subject<any>();
  private menuIsFoldedSource = new Subject<boolean>();

  constructor() { }

  // Observable  streams
  companyList$ = this.companyListSource.asObservable();
  loginState$ = this.loginStateSource.asObservable();
  menuItems$ = this.menuItemsSource.asObservable();
  currentUser$ = this.currentUserSource.asObservable();
  companyIndice$ = this.companyIndiceSource.asObservable();
  loadingState$ = this.loadingStateSource.asObservable();
  notificationList$ = this.notificationListSource.asObservable();
  appTitle$ = this.appTitleSource.asObservable();
  appSubTitle$ = this.appSubTitleSource.asObservable();
  menuIcon$ = this.menuIconSource.asObservable();
  dragAndDropMvt$ = this.dragAndDropMvtSource.asObservable();
  snackBarIsClose$ = this.snackBarIsCloseSource.asObservable();
  snackBarClose$ = this.snackBarCloseSource.asObservable();
  helpButton$ = this.HelpButtonSource.asObservable()
  menuIsFolded$ = this.menuIsFoldedSource.asObservable()
  poolDragAndDrop$ = this.poolDragAndDropSource.asObservable()
  


  public setLogin(loginState: boolean) {
    this.loginStateSource.next(loginState);
  }
  public setcompanyList(companyList: companyDetails[]) {
    this.companyListSource.next(companyList);
  }
  public setMenuItems(menuAppItem: menuAppItems[]) {
    this.menuItemsSource.next(menuAppItem);
  }
  public setCurrentUser(currentUser: currentUser) {
    this.currentUserSource.next(currentUser);
  }
  public setcompanyIndice(companyIndice: string) {
    this.companyIndiceSource.next(companyIndice);
  }
  public setLoadingState(loadingState: boolean) {
    this.loadingStateSource.next(loadingState);
  }
  public setsnackBarIsClose(snackBarIsClose: boolean) {
    this.snackBarIsCloseSource.next(snackBarIsClose);
  }
  public setsnackBarClose() {
    this.snackBarCloseSource.next(null);
  }
  public setNotification(notificationList: notification[]) {
    this.notificationListSource.next(notificationList);
  }
  public setAppTitle(appTitle: string) {
    this.appTitleSource.next(appTitle);
  }
  public setAppSubTitle(appTitle: string) {
    this.appSubTitleSource.next(appTitle);
  }
  public setMenuIcon(icon: string) {
    this.menuIconSource.next(icon)
  }
  public setPoolDragAndDrop(item: any) {
    this.poolDragAndDropSource.next(item)
  }
  public setDragAndDropMvt(item: boolean) {
    this.dragAndDropMvtSource.next(item)
  }
  public setHelpButton(item: any) { //display component 
    this.HelpButtonSource.next(item)
  }

  public setMenuIsFolded(item : boolean)
  {
    this.menuIsFoldedSource.next(item)
  }

  public fileAsConverter(prenom: string, nom: string, fileAsMode: number): string {
    switch (fileAsMode) {
      case 0:
        return nom.charAt(0).toUpperCase() + nom.slice(1) + " " + prenom.charAt(0).toUpperCase() + prenom.slice(1)
        break;
      case 1:
        return nom.toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.slice(1)
        break;
      case 2:
        return prenom.charAt(0).toUpperCase() + prenom.slice(1) + " " + nom.charAt(0).toUpperCase() + nom.slice(1)
        break;
      case 3:
        return prenom.charAt(0).toUpperCase() + prenom.slice(1) + " " + nom.toUpperCase()
        break;
      default:
        return prenom + ', ' + nom
        break;
    }
  }

  public strMapToObj(obj :any) {
    let strMap = new Map();
    for (let k of Object.keys(obj)) {
      strMap.set(k, obj[k]);
    }
    return strMap;
  }
}

export interface menuAppItems {
  icon: string;
  title: string;
  permission: string;
  subTitle: string;
  divider: boolean;
  pageUrl: string;
  ngStyle: {};
  subItems? : menuAppItems[];
  subItemId? : string //object generate automatically 
}

export interface accesList {
  subscriberId: string;
  permissions: [string]
}

export interface companyDetails {
  name: string;
  logo: string; //svgIcon base64 img
  companyGuid: string;
  subscriberDatabaseName: string;
  subscriberDatabasePort: number;
  applications: application[];
  host: string;
}

export interface application {
  playStoreUrl: string;
  iosUrl: string;
  displayName: string;
  applicationName: string;
  description: string;
  publicationDate: Date;
  documentationUrl: string,
  presentationUrl: string,
  active: boolean;
  applicationUrl: string;
  svgIcon: SafeUrl | any;
  htmlDescription: SafeHtml;
  svgIllustration: SafeUrl;
  isRegister?: boolean;
  userCount?: string;
  fileAs? : string;
  apis? : apis[]
}

export interface apis {
  active: boolean,
  apiName: string,
  apiUrl: string,
  description: string,
  displayName: string,
  documentationUrl: string,
  fileAs: string,
  htmlDescription: string,
  maintenance: boolean,
  presentationUrl: string,
  svgIcon: string,
  svgIllustration: string,
  tags: string,
  version: string
}

export interface notification {
  dateNotification: Date;
  message: string;
  urlRedirection: string;
  informationLevel: number;
}

export interface currentUser {
  displayName: string;
  firstName: string;
  lastName: string;
  userName: string
}

export interface currentCompany {
  idCompany: string;
}

